<template>
  <div class="lesson-header">
    <z-badge-text
      :value="categoryName"
      class="lesson-header__tag"
    />

    <z-title
      class="lesson-header__title"
      tag="h1"
      weight="normal"
    >
      {{ title }}
    </z-title>

    <z-text
      weight="normal"
      color="minor"
      align="center"
      class="lesson-header__subtitle"
    >
      Publicado por
      <z-link :href="`/revista/autor/${authorSlug}`">
        {{ authorFullName }}
      </z-link>
      <span v-if="showDate">| Última atualização: {{ showDate }}</span>
    </z-text>
  </div>
</template>

<script>
export default {
  name: 'LessonHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    authorFullName: {
      type: String,
      required: true,
    },
    authorSlug: {
      type: String,
      required: true,
    },
    categoryName: {
      type: String,
      required: true,
    },
    showDate: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.lesson-header {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--unit-0200);
  justify-content: center;
  padding: var(--unit-0600) 0 var(--unit-1000);

  @media (min-width: $breakpoint-tablet) {
    padding: var(--unit-1200) 0;
  }
}

.lesson-header__tag {
  background-color: var(--color-blue-000);
  color: var(--color-blue-800);
  padding: var(--unit-0100) var(--unit-0200);

  @media (max-width: $breakpoint-tablet) {
    margin-bottom: var(--unit-0200);
  }
}

.lesson-header__title {
  font-size: 1.75rem;
  margin: 0 0;
  line-height: 124%;

  @media (min-width: $breakpoint-tablet) {
    font-size: 3rem;
    line-height: 132%;
  }
}

.lesson-header__subtitle {
  font-size: .875rem;

  @media (min-width: $breakpoint-tablet) {
    font-size: var(--unit-0400);
  }
}

.lesson__author {
  align-items: center;
  display: flex;
}
</style>
